/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Quality_Enum, quality_EnumFromJSON, quality_EnumToJSON } from "../../../../gen/gnss_solver/quality";

export const protobufPackage = "skills";

export interface SetGnssSolverQualityActionArgs {
  quality: Quality_Enum;
}

export interface SetGnssSolverQualityResultData {
}

export interface SetGnssSolverQualityActionStateData {
}

function createBaseSetGnssSolverQualityActionArgs(): SetGnssSolverQualityActionArgs {
  return { quality: 0 };
}

export const SetGnssSolverQualityActionArgs = {
  encode(message: SetGnssSolverQualityActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.quality !== 0) {
      writer.uint32(8).int32(message.quality);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetGnssSolverQualityActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetGnssSolverQualityActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.quality = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetGnssSolverQualityActionArgs {
    return { quality: isSet(object.quality) ? quality_EnumFromJSON(object.quality) : 0 };
  },

  toJSON(message: SetGnssSolverQualityActionArgs): unknown {
    const obj: any = {};
    if (message.quality !== 0) {
      obj.quality = quality_EnumToJSON(message.quality);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetGnssSolverQualityActionArgs>, I>>(base?: I): SetGnssSolverQualityActionArgs {
    return SetGnssSolverQualityActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetGnssSolverQualityActionArgs>, I>>(
    object: I,
  ): SetGnssSolverQualityActionArgs {
    const message = createBaseSetGnssSolverQualityActionArgs();
    message.quality = object.quality ?? 0;
    return message;
  },
};

function createBaseSetGnssSolverQualityResultData(): SetGnssSolverQualityResultData {
  return {};
}

export const SetGnssSolverQualityResultData = {
  encode(_: SetGnssSolverQualityResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetGnssSolverQualityResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetGnssSolverQualityResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetGnssSolverQualityResultData {
    return {};
  },

  toJSON(_: SetGnssSolverQualityResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetGnssSolverQualityResultData>, I>>(base?: I): SetGnssSolverQualityResultData {
    return SetGnssSolverQualityResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetGnssSolverQualityResultData>, I>>(_: I): SetGnssSolverQualityResultData {
    const message = createBaseSetGnssSolverQualityResultData();
    return message;
  },
};

function createBaseSetGnssSolverQualityActionStateData(): SetGnssSolverQualityActionStateData {
  return {};
}

export const SetGnssSolverQualityActionStateData = {
  encode(_: SetGnssSolverQualityActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetGnssSolverQualityActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetGnssSolverQualityActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetGnssSolverQualityActionStateData {
    return {};
  },

  toJSON(_: SetGnssSolverQualityActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetGnssSolverQualityActionStateData>, I>>(
    base?: I,
  ): SetGnssSolverQualityActionStateData {
    return SetGnssSolverQualityActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetGnssSolverQualityActionStateData>, I>>(
    _: I,
  ): SetGnssSolverQualityActionStateData {
    const message = createBaseSetGnssSolverQualityActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
